var map = {
	"./Kentico.svg": 60212,
	"./Kontent.svg": 94388,
	"./Strapi.svg": 15551,
	"./about-skating-butler.svg": 47972,
	"./amazon.svg": 13502,
	"./atom.svg": 50570,
	"./backgrounds/background-line-arrow-head.svg": 6014,
	"./backgrounds/background-line.svg": 3699,
	"./backgrounds/cloud-dots-bottom.svg": 47581,
	"./backgrounds/cloud-dots-top.svg": 56476,
	"./backgrounds/cloud-page_header-dots-a.svg": 90462,
	"./backgrounds/cloud-page_header-dots-b.svg": 33766,
	"./backgrounds/cloud-page_proof-arrow.svg": 86740,
	"./backgrounds/cloud-page_proof-watermark.svg": 21868,
	"./backgrounds/concierge-form-bg-left-bottom.svg": 44952,
	"./backgrounds/concierge-form-bg-left-center.svg": 28763,
	"./backgrounds/concierge-form-bg-right-center.svg": 22031,
	"./backgrounds/concierge-page_header-a.svg": 22160,
	"./backgrounds/concierge-page_header-b.svg": 22026,
	"./backgrounds/concierge-page_header-c.svg": 22108,
	"./backgrounds/cta-block-hands-a.svg": 12190,
	"./backgrounds/cta-block-hands-b.svg": 48474,
	"./backgrounds/cta-block-hands-c.svg": 88289,
	"./backgrounds/home_dots.svg": 17744,
	"./ball-being-rolled.svg": 99658,
	"./bg-home.svg": 18005,
	"./checkmark.svg": 8046,
	"./color-blocks.svg": 43895,
	"./concierge-account-management.svg": 71703,
	"./concierge-audit.svg": 81442,
	"./concierge-review.svg": 73366,
	"./concierge-slack-channel.svg": 76385,
	"./concierge-ticket-prioritization.svg": 71896,
	"./concierge-training.svg": 85302,
	"./contentful.svg": 34839,
	"./contentstack.svg": 32822,
	"./datocms.svg": 58397,
	"./diagram/cdn-mini.svg": 63123,
	"./diagram/cdn-new.svg": 59772,
	"./diagram/cdn.svg": 17294,
	"./diagram/cli-big.svg": 41633,
	"./diagram/cli-mini.svg": 92540,
	"./diagram/cms-big.svg": 60420,
	"./diagram/cms-documents.svg": 93383,
	"./diagram/cms-mini.svg": 42769,
	"./diagram/cms.svg": 92716,
	"./diagram/code-documents.svg": 66331,
	"./diagram/content-creator.svg": 40365,
	"./diagram/database.svg": 27925,
	"./diagram/developer.svg": 43270,
	"./diagram/filesystem.svg": 69711,
	"./diagram/react.svg": 61360,
	"./diagram/user-new-small.svg": 94976,
	"./diagram/user-new.svg": 36172,
	"./diagram/user.svg": 64071,
	"./docs-keyvisual-conceptual-guides.svg": 1708,
	"./docs-keyvisual-homepage.svg": 77598,
	"./docs-keyvisual-how-to-guides.svg": 89001,
	"./docs-keyvisual-reference-guides.svg": 55079,
	"./docs-keyvisual-tutorials.svg": 51552,
	"./drupal.svg": 43997,
	"./gatsby-days-logo.svg": 9027,
	"./guides-astronaut-butler.svg": 37093,
	"./guides-markdown.svg": 61248,
	"./guides-react-hero-bottom.svg": 35483,
	"./guides-react.svg": 57325,
	"./guides-stars.svg": 62807,
	"./hand-dropping-ball.svg": 85730,
	"./hosting.svg": 80772,
	"./icon-apps.svg": 44962,
	"./icon-data.svg": 82200,
	"./icon-deployment.svg": 48079,
	"./icon-link.svg": 50232,
	"./icon-performance.svg": 29127,
	"./icons/article.svg": 46802,
	"./icons/gatsby-4-icon.svg": 75780,
	"./icons/md-arrow-forward.svg": 62928,
	"./integrations-circle.svg": 82098,
	"./integrations-hexagon.svg": 72547,
	"./integrations-polygon.svg": 27227,
	"./integrations-two-squares.svg": 18033,
	"./jekyll.svg": 36611,
	"./light-purple-dot.svg": 94707,
	"./logo.svg": 3104,
	"./markdown.svg": 49961,
	"./monogram.svg": 74947,
	"./netlify-grayscale.svg": 23946,
	"./netlify.svg": 80914,
	"./nextjs.svg": 69910,
	"./pictures/cloud-page_cms-previews-desktop.svg": 78655,
	"./pictures/cloud-page_cms-previews-mobile.svg": 81114,
	"./pictures/cloud-page_deploy-previews-desktop.svg": 84765,
	"./pictures/cloud-page_deploy-previews-mobile.svg": 74154,
	"./pictures/cloud-page_incremental-builds-desktop.svg": 38710,
	"./pictures/cloud-page_incremental-builds-mobile.svg": 53069,
	"./pictures/cloud-page_lighthouse-reports-desktop.svg": 24150,
	"./pictures/cloud-page_lighthouse-reports-mobile.svg": 99961,
	"./pwa.svg": 70716,
	"./pwa_card.svg": 85316,
	"./react.svg": 49192,
	"./sanitize.svg": 2089,
	"./sanity.svg": 89176,
	"./silly-site-award.svg": 6169,
	"./silly-site-background.svg": 48919,
	"./silly-site-challenge-pattern-light.svg": 166,
	"./silly-site-challenge-pattern.svg": 7986,
	"./silly-site-shapes.svg": 11658,
	"./silly-site-swag.svg": 3986,
	"./source.svg": 21984,
	"./support-cloud-knowledge-base.svg": 6103,
	"./support-form-background.svg": 27984,
	"./support-form-hand.svg": 80057,
	"./support-open-source-docs.svg": 63724,
	"./support-product-roadmap.svg": 53308,
	"./support-status-page.svg": 6256,
	"./use-case-ellipse-2.svg": 29156,
	"./use-case-ellipse.svg": 6736,
	"./use-case-polygon.svg": 13002,
	"./use-case-rectangle.svg": 4175,
	"./why-gatsby-bg-block-1.svg": 73036,
	"./why-gatsby-bg-block-2.svg": 61689,
	"./why-gatsby-blazing-fast-websites.svg": 17093,
	"./why-gatsby-delight-developers.svg": 5842,
	"./why-gatsby-ensure-safety.svg": 24723,
	"./why-gatsby-exceed-expectations.svg": 39437,
	"./why-gatsby-stars.svg": 58956,
	"./why-gatsby-start-quickly.svg": 59999,
	"./wordpress.svg": 43444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82069;